import { Navigate } from 'react-router-dom'
import useCurrentUser from '../hooks/useCurrentUser'

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useCurrentUser()
  if (loading) {
    return <div>Loading...</div>
  }
  if (!user) {
    return <Navigate to="/" replace />
  }
  return children
}

export default ProtectedRoute
